




















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';
import { ICheckoutCartOfferPrice } from '@/interfaces/Checkout';

@Component({
  components: {
    ScreenSizeVisibility
  }
})
export default class InvoiceDetails extends Vue {
  @Prop({ default: '' })
  private intervalType!: string;

  @Prop({ default: '' })
  private offerTitle!: string;

  @Prop()
  private invoice: any;

  @Prop({ default: false })
  private isRenewal: boolean;

  @Prop({ default: false })
  private hasRewardsPoints: boolean;

  @Prop()
  private selectedOfferPrice: ICheckoutCartOfferPrice;

  get offerPrice() {
    return this.selectedOfferPrice && this.selectedOfferPrice.price;
  }

  get offerPointsPrice() {
    return this.selectedOfferPrice && this.selectedOfferPrice.points_price;
  }

  get intervalTypeName(): string {
    if (!this.intervalType) return '';

    return `(${this.$t(`App.Checkout.intervalType.${this.intervalType}`)})`;
  }

  private get TitleHeader(): string {
    return !this.isRenewal
      ? 'App.Checkout.Offer.summary'
      : 'App.Checkout.Offer.renew.summary';
  }

  private get ABPrice() {
    return this.$route.query.p === '1';
  }

  private get points(){
    return this.selectedOfferPrice &&
           this.selectedOfferPrice.points_price &&
           this.hasRewardsPoints;
  }

  private get rewardsPoints(){
    return this.selectedOfferPrice &&
           this.selectedOfferPrice.points_price &&
           this.selectedOfferPrice.price &&
           this.hasRewardsPoints;
  }

  private get pointsPrice(){
    return this.selectedOfferPrice &&
           this.selectedOfferPrice.price;
  }
  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
